import React from 'react';
import PropTypes from 'prop-types';
import { prettyNumber, metersToFeet } from '../../../../../lib/utils';
import DataPoint from '../DataPoint';
import Divider from '../Divider';

export default function WaypointStats(props) {
  const point = props.feature;

  const hasGeometry = () => {
    return point && point.geometry && point.geometry.coordinates;
  };

  const getLatitude = () => {
    if (
      !props.hideCoords &&
      hasGeometry() &&
      point.geometry.coordinates[1] != null
    ) {
      return point.geometry.coordinates[1].toFixed(6);
    }
    return '--';
  };

  const getLongitude = () => {
    if (
      !props.hideCoords &&
      hasGeometry() &&
      point.geometry.coordinates[0] != null
    ) {
      return point.geometry.coordinates[0].toFixed(6);
    }
    return '--';
  };

  const getElevation = () => {
    if (
      !props.hideCoords &&
      hasGeometry() &&
      point.geometry.coordinates[2] != null &&
      point.geometry.coordinates[2] !== 0
    ) {
      return prettyNumber(metersToFeet(point.geometry.coordinates[2]), 0);
    }
    return '--';
  };

  return (
    <>
      <DataPoint title='Location'>
        {getLatitude() + '°'}, {getLongitude() + '°'}
      </DataPoint>
      <Divider margin={24} />
      <DataPoint title='Elevation'>{getElevation() + '\''}</DataPoint>
    </>
  );
}

WaypointStats.propTypes = {
  feature: PropTypes.object,
  hideCoords: PropTypes.bool,
};
